module.exports = __webpack_public_path__ + "static/pic03@2xwebp-e027f62738b8f72b494dcd1d03908202.webp";